import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export default class TextInput extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    isPassword: PropTypes.bool,
    onChange: PropTypes.func
  };

  uniqueID = "";
  componentWillMount() {
    this.uniqueID = Date.now();
  }

  render() {
    const { label, value, isPassword, onChange } = this.props;
    return (
      <Wrapper>
        <Label htmlFor={this.uniqueID}>{label}</Label>
        <Input
          id={this.uniqueID}
          type={isPassword ? "password" : "text"}
          value={value}
          onChange={onChange}
        />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

const Label = styled.label`
  color: #fff;
`;

const Input = styled.input`
  background-color: transparent;
  padding: 8px;
  border: none;
  border-bottom: solid 2px ${props => props.theme.loginInputBottomBorder};
  color: #fff;
  font-size: 1.5rem;
  transition: border 0.3s;
  &:focus {
    outline: none;
    border-bottom: solid 2px ${props => props.theme.loginInputBottomBorderHover};
  }
`;



// WEBPACK FOOTER //
// ./src/module-login/TextInput.js